/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CustomerServiceProjectSettingsRedirectEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const customerServiceProjectSettingsRedirectEntrypoint: EntryPoint<
	CustomerServiceProjectSettingsRedirectEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CustomerServiceProjectSettingsRedirectEntrypointComponent>(
		/* webpackChunkName: "async-customer-service-project-settings-redirect-entrypoint" */ './CustomerServiceProjectSettingsRedirect.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
});
